export default {
  'mode': 'production',
  'app': 'elu',
  'version': '5.0.12',
  'environnement' : {
    prod: {
      'client_id': '2_app_ce_047398937364363',
      'client_secret': '984307987897483',
      'apiUrl': 'https://api-preprod.ekipea.fr',
      'hcaptcha_sitekey': '15b60d2a-a12a-493e-96cc-c5d0beb21efa',
    },
    preprod: {
      'client_id': '2_app_ce_047398937364363',
      'client_secret': '984307987897483',
      'apiUrl': 'https://api-preprod.ekipea.fr',
      'hcaptcha_sitekey': '15b60d2a-a12a-493e-96cc-c5d0beb21efa',
    }
  },
  web: true,
  notifications: {
    onesignal_app_id: '0e146d36-afd2-4a1f-b3b5-d3a4a8d69ee0',
    google_project_number: '31414490528'
  },
  stores: {
    android: 'https://play.google.com/store/apps/details?id=ekipea.salarie&hl=fr',
    androidV2: 'https://play.google.com/store/apps/details?id=fr.ekipea.pocketcse&hl=fr',
    ios: 'https://apps.apple.com/fr/app/pocketce/id1400652429',
    iosV2: 'https://apps.apple.com/fr/app/pocketcse/id6484265799',
  },
  packageName: 'ekipea.elu'
};



// WEBPACK FOOTER //
// ./src/env/current.ts